import IEvent from "../../dataProvider/interfaces/IEvent";
import { useState } from "react";
import { EventFormNew } from "./EventFormNew";
import { useForm } from "react-hook-form";
import React from "react";

export interface Props {
  event?: IEvent;
  formSubmit: (values: any) => void;
  // imageSelect?: Function;
  onChange?: () => void; // callback to be executed on form change
}
  
const EventForm = ({ event, formSubmit, onChange }: Props) => {
  const datePlusOne = new Date().getTime() + 1 * 60 * 60 * 1000

  const [defaultTime, ] = useState({
    startDate: new Date(datePlusOne),
    endDate: new Date(datePlusOne)
  });

  
  const initialValues = {
    eventName: (event && event.name) || "",
    eventLocation: (event && event.locationName) || "",
    eventCity: (event && event.city) || "",
    eventStartDate: defaultTime.startDate,
    eventEndDate: defaultTime.endDate,
    eventTimezone: (event && event.timeZone) || "",
    eventGroup: (event && event.group) || "",
    eventArchiveInterval: (event && event.archivingPeriod) || "14",
    hasFraudDetection: Boolean(event && event.hasFraudDetection) || false,
  };

  

  async function onSubmit(values: any) {
    formSubmit(values);
  }


  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues
  } = useForm({
    defaultValues: initialValues,
  });

  return (
         <form
              id="eventForm"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              style={{ width: "100%", textAlign: "left" }}
            >
              <EventFormNew 
                register={register}
                control={control}
                getValues={getValues}
                errors={errors}
                selectedEvent={false}
                isEventInfo={false}
              />
            </form>
  );
};

export default EventForm;
